<template>
    <b-row>
        <b-col cols="12">
            <b-card>
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="p-1">
                        <form class="" @submit.prevent="submitForm">
                            <div class="row">
                                <div class="form-group col-12 col-md-6">
                                    <label for="phone24">Nombre:</label>
                                    <b-form-input v-model="inspection_made_by.made_by" autocomplete="off"/>
                                    <span v-if="validation_inspection_made_by.made_by" class="text-danger">
                                      {{ validation_inspection_made_by.made_by }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput, BFormCheckbox, BFormGroup} from 'bootstrap-vue'
import {mapState} from "vuex"
import {GEI_AUXILIAR_INSPECTIONMADEBY_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
    getterType: 'inspectionMadeBys/getField',
    mutationType: 'inspectionMadeBys/updateField',
})

export default {
    name: "FormView",
    components: {
        BCol,
        BRow,
        BCard,
        BFormInput,
        BOverlay,
    },
    data() {
        return {
            edit: false,
            showLoading: false,
        }
    },
    computed: {
        ...mapState('auxiliariesInspectionMadeBy', ['validation_inspection_made_by']),
        ...mapFields({
          inspection_made_by: 'inspection_made_by',
        }),
    },
    created() {
        this.$store.commit('auxiliariesInspectionMadeBy/RESET_STATE')
        this.$store.commit('auxiliariesInspectionMadeBy/CLEAR_VALIDATION')
        if (this.$route.params.id) {
            this.edit = true
            this.getInspectionMadeBy()
        } else {
            this.edit = false
        }
        this.$root.$refs.auxiliariesInspectionMadeByForm = this
    },
    methods: {
      getInspectionMadeBy() {
            this.showLoading = true

            this.$store.dispatch('inspectionMadeBys/findInspectionMadeBy', {
                id: this.$route.params.id ?? this.inspection_made_by.id
            })
                .then(response => {
                  this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                })
        },
        cancel() {
            this.$router.push(GEI_AUXILIAR_INSPECTIONMADEBY_LIST)
        },
        createAuxiliar() {
            this.$store.dispatch('inspectionMadeBys/createInspectionMadeBy', this.inspection_made_by)
                .then(response => {
                    helper.showToast('Inspección creada correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(GEI_AUXILIAR_INSPECTIONMADEBY_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al crear inspección', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        updateAuxiliar() {
            this.$store.dispatch('inspectionMadeBys/updateInspectionMadeBy', this.inspection_made_by)
                .then(response => {
                    helper.showToast('Inspección editada correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(GEI_AUXILIAR_INSPECTIONMADEBY_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al editar la inspección', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        submitForm() {
            if (this.$route.params.id) {
                this.updateAuxiliar()
            } else {
                this.createAuxiliar()
            }
        },
    },
}
</script>
